$(document).ready(function(){
    $('.cp_stats_grid').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        speed: 300,
        slidesToShow: 5,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
        ]
    });

    $('.cp_faq_box').click(function(){
      $(this).toggleClass('active');
      $(this).find('.cp_faq_content').slideToggle();
    });


    $('.cp_choose_carousel').slick({
        dots: true,
        arrows: true,
        slidesToShow: 1,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_to_Right_1.png?v=1747382864'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_to_Right.png?v=1747382863'/></button>",
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });

    $('.cp_video_carousel').slick({
      dots: true,
      arrows: true,
      slidesToShow: 4,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '30px'
            }
          }
      ]
  });

  $('.cp_video_nav_prev').click(function(){
    $('.cp_video_carousel').find('.slick-prev').trigger('click');
  });

  $('.cp_video_nav_next').click(function(){
    $('.cp_video_carousel').find('.slick-next').trigger('click');
  });

  $('.cp_video_box').click(function() {
    // Get the video inside the clicked box
    $('.cp_video_box').removeClass('active');
    const clickedVideo = $(this).find('video').get(0);

    // Pause all other videos
    $('video').each(function() {
        if (this !== clickedVideo) {
            this.pause();
        }
    });

    // Toggle play/pause for the clicked video
    if (clickedVideo.paused) {
        clickedVideo.play();
        $(this).addClass('active');
    } else {
        clickedVideo.pause();
    }
});
});